import React from 'react';
import Modal from 'react-responsive-modal';

import Loading from '../loading';

const FeedbackModal = ({
	open,
	type,
	title,
	content,
	onCloseModal,
	buttonConfirm,
	buttonDecline,
	confirmAction,
	declineAction,
	isLoading,
}) => {
	return (
		<div className="feedback-modal-container">
			<Modal
				classNames={{
					modal: `feedback-modal ${type === 'alert' ? 'alert' : type === 'info' ? 'info' : ''}`,
					closeButton: 'close-btn',
				}}
				open={open}
				onClose={onCloseModal}>
				<div className="inner">
					<div className="icon">
						{type === 'alert' ? (
							<i className="fad fa-exclamation-triangle"></i>
						) : type === 'info' ? (
							<i className="fad fa-info-circle"></i>
						) : (
							<i className="fad fa-info-circle"></i>
						)}
					</div>
					<div className="content">
						<h3>{title}</h3>
						<p>{content}</p>
						<div className="buttons">
							{buttonDecline && (
								<button className="btn btn-default" onClick={() => declineAction()}>
									{buttonDecline}
								</button>
							)}

							<button
								disabled={isLoading ? true : false}
								className="btn btn-confirm"
								onClick={() => confirmAction('id')}>
								{isLoading && <Loading />}
								<span>{buttonConfirm}</span>
							</button>
						</div>
					</div>
				</div>
			</Modal>
		</div>
	);
};

export default FeedbackModal;
